
import "./aesthetic.css";

export default function Aesthetic() {
    return(
        <div>teste de conteúdo estético</div>
    )
}